import { Component, Input, OnInit } from '@angular/core';
import { isImage } from '../../shared/constants';
import { Router } from '@angular/router';
import { ApiService } from '../../api.service';
import { ToastrService } from 'ngx-toastr';

@Component({
	selector: 'view-attachments',
	templateUrl: './view-attachments.component.html',
	styleUrl: './view-attachments.component.scss'
})
export class ViewAttachmentsComponent implements OnInit {
	constructor(private toastr: ToastrService, private apiService: ApiService) { }
	ngOnInit(): void {
		this.apiService.setAttachmentData([]);
		/* this.apiService.attChangedData$.subscribe((data) => {
			if (data && data.id && data.id == this.mailId) {
				this.attachmentsArr = JSON.parse(data.attachment);
			}
		}) */
	}
	@Input() attachmentsArr: any[] = [];
	@Input() mailId: any = null;
	@Input() apptId: any = null;
	@Input() showDelete = false;
	@Input() allowBillingLink = false;
	defaultIcon = "../../../assets/img/file.png";

	isImage(name) {
		return isImage(name);
	}

	getName(name: any) {
		try {
			return name.split("/").pop();
		} catch (error) {
			return name;
		}
	}

	getShortName(name: string) {
		try {
			name = this.getName(name);
			const limit = 20;
			const trail = '...';
			return name.length > limit ? name.substring(0, limit) + trail : name;
		} catch (error) {
			return name;
		}
	}

	removeAttachment(att: any) {
		this.attachmentsArr.splice(this.attachmentsArr.indexOf(att), 1);
	}

	selectFiles(type: string) {
		const selectedAtt = this.attachmentsArr.filter((att: any) => att.selected);
		if (!selectedAtt.length) {
			this.toastr.error('No attachment is selected', 'Error', {
				timeOut: 3000,
				tapToDismiss: true,
				closeButton: true
			});
			return;
		}
		this.apiService.setAttachmentData({ mailId: this.mailId, attachments: this.attachmentsArr, type: type });
		const type_msg = type == "bill" ? "billing" : "files";
		this.toastr.success('Files selected for ' + type_msg, 'Files selected', {
			timeOut: 3000,
			tapToDismiss: true,
			closeButton: true
		});
	}
}
